import { request } from './http';

export interface DashboardSummary {
  /** 母账户余额（整数美分） */
  walletBalanceCents: number;
  /** 累计已开通有效卡数量 */
  activeCardCount: number;
  /** 当月已消费（整数美分） */
  monthSpentCents: number;
  /** 当月成功率（0-1 浮点） */
  monthSuccessRate: number;
}

export interface DashboardSpendPoint {
  date: string;
  amountCents: number;
}

export const dashboardApi = {
  summary() {
    return request<DashboardSummary>({ url: '/dashboard/summary', method: 'GET' });
  },
  spendTrend(days: number = 30) {
    return request<DashboardSpendPoint[]>({
      url: '/dashboard/spend-trend',
      method: 'GET',
      params: { days },
    });
  },
};
